var _defs, _rect, _g, _g2, _text;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardUpgradeFisica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 360",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgUpgrade",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b82f6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "url(#bgUpgrade)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(260 165)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 5,
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -45,
    width: 140,
    height: 90,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: -54,
    y: -28,
    width: 108,
    height: 16,
    fill: "#ffffff",
    opacity: 0.6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -54,
    y: 4,
    width: 64,
    height: 10,
    fill: "#ffffff",
    opacity: 0.4,
    stroke: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(420 180)",
    fill: "#ffffff",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: -22,
    width: 64,
    height: 44,
    rx: 4,
    ry: 4,
    fill: "#ffffff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -20 -22 L -20 -34 L 20 -34 L 20 -22",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -14,
    cy: 34,
    r: 5,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 34,
    r: 5,
    fill: "#ffffff"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 290,
    textAnchor: "middle",
    fontFamily: "Inter, system-ui, sans-serif",
    fontSize: 26,
    fontWeight: 800,
    fill: "#ffffff",
    letterSpacing: 2
  }, "UPGRADE F\xCDSICA + FRETE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardUpgradeFisica);
export default __webpack_public_path__ + "static/media/card-upgrade-fisica.393dd96e1db8cf9243c193e61630031e.svg";
export { ForwardRef as ReactComponent };